<template>
	<section class="admin-content">
		<div class="login-admin" v-if="!loggedIn">
			<input class="login_input" 
				autocomplete="off"
				placeholder="username"
				v-model="username"/>
			<input class="password_input" 
				autocomplete="off"
				placeholder="password"
				type="password"
				v-model="password"/>
			<div class="submit_input" v-on:click="adminLogin(username,password)">
				<label>Log in</label>
			</div>
		</div>
		<div v-else>
			<div class="admin-menu">
				<div v-on:click="loadUsers();loadSettings();currentPage=0" class="menuButton admin-menuButton">
					SETTNGS
				</div>
				<div v-on:click="loadCustomers();currentPage=1" class="menuButton admin-menuButton">
					CUSTOMERS
				</div>
				<div v-on:click="currentPage=2" class="menuButton admin-menuButton">
					AUDITION
				</div>
				<div v-on:click="currentPage=3" class="menuButton admin-menuButton">
					FAQ
				</div>
				<div v-on:click="loadTexts();currentPage=4" class="menuButton admin-menuButton">
					Texts
				</div>
				<div v-on:click="loadMembers();currentPage=5" class="menuButton admin-menuButton">
					Team Members
				</div>
				<div v-on:click="loadEmails();currentPage=6" class="menuButton admin-menuButton">
					Emails
				</div>
			</div>
			<div id="settings" v-if="currentPage==0">
			<h3>Admin users</h3>
			<div class="adminUsers" v-if="users.length > 0">
				
				<table>
				  <tr>
					<th>users</th>
					<th>Delete</th>
				  </tr>
				  <tr class="table-row" v-for="user in users">
					<td>{{user.user}}</td>
					<td><button v-on:click="deleteUser(user.user)">
							Delete
					</button></td>
				  </tr>
				  </table>
			   </div>
			<table>
				  <tr>
					<th><input class="login_input" 
				autocomplete="off"
				placeholder="username"
				v-model="username"/></th>
					<th><input class="password_input" 
				autocomplete="off"
				placeholder="password"
				type="password"
				v-model="password"/></th>
					<th>	<div class="submit_input" v-on:click="registerNewUser(username,password)">
				<label>Create new user</label>
			</div></th>
				  </tr>
			</table>			  
			
			<div class="settings" v-if="settings.length > 0">
				<h3>Settings</h3>
				<table>
				  <tr>
					<th>settingName</th>
					<th>Value</th>
					<th>Update</th>
				  </tr>
				  <tr class="table-row" v-for="setting in settings">
					<td>{{setting.name}}</td>
					<td>
					<div  v-if="setting.options.length > 0" v-for="soption in setting.options" class="table-value-Input">
						<input type="radio" :id="soption" v-model="setting.value" v-bind:value="soption+'#'+setting.options.join('#')">
						<label :for="soption">{{soption}}</label>
					</div>
					<div v-else>
					<input class="table-value-Input" 
				autocomplete="off"
				v-model="setting.value"
				/>
				</div>
				</td>
					<td><button v-on:click="updateSettings(setting.name,setting.value)">
							Save
					</button></td>
				  </tr>
				  </table>
			   </div>
			</div>
			
			<div id="subscribed-customers" v-if="currentPage==1">
				<h3>Customers</h3>
				<div style="height:500px;">
					<div style="float:right;height:100%;width:450px;border:solid 1px #FF632B;">
						<AddCustomer></AddCustomer>
					</div>
					<div style="float:right;height:100%;width:450px;border:solid 1px #FF632B;">
						<h3>רישום לאודישן</h3>
						<Audition :auditionType="chosenAudition"></Audition>
					</div>
				</div>
				</br>
				</br>
				</br>
				</br>
				</br>
				<button v-on:click="createCSV()">
							יצא טבלה
					</button>
				<table>
				  <tr>
					<th v-on:click="sortCustormersBy('site');">סניף</th>
					<th v-on:click="sortCustormersBy('user_id');">מזהה יחודי</th>
					<th v-on:click="sortCustormersBy('creation_time');">תאריך הוספה למערכת</th>
					<th v-on:click="sortCustormersBy('name');">שם</th>
					<th v-on:click="sortCustormersBy('instrument');">כלי ראשי</th>
					<th v-on:click="sortCustormersBy('email');">מייל</th>
					<th v-on:click="sortCustormersBy('phone');">טלפון</th>
					<th v-on:click="sortCustormersBy('audition_type');">סוג אודישן</th>
					<th v-on:click="sortCustormersBy('time');">רשום לאודישן</th>
					<th v-on:click="sortCustormersBy('deal_id');">מספר עסקה</th>
					
				  </tr>
				  <tr class="table-row" v-for="customer in customers">
					<td>{{customer.site}}</td>
					<td>{{customer.user_id}}</td>
					<td>{{ new Date(parseInt(customer.creation_time)).toString()}}</td>
					<td>{{customer.name}}</td>
					<td>{{customer.instrument}}</td>
					<td>{{customer.email}}</td>
					<td>{{customer.phone}}</td>
					<td>{{customer.audition_type}}</td>
					<td>{{customer.booked_time ? ( customer.time ?  customer.day.split("T")[0] + " ,    " + customer.time : "" ) : "" }}</td>
					<td>{{customer.booked_time ? customer.deal_id : ""}}</td>
					
					<td><button v-on:click="deleteCustomer(customer.user_id)">
							Delete
					</button></td>
				  </tr>
				  </table>
			</div>
			
			
			<div class="auditions"  v-if="currentPage==2">
				<h3>Auditions</h3>

				<table class="faqTable">
					<tr  class="table-row">
							<td> 
			
							<h4>קובץ הנחיות</h4></br>
							<a :href="audition_instructions" target="_blank"><h4>לחץ כאן לצפיה בקובץ נוכחי</h4></a>
							<input  type="file" v-on:change="uploadAuditionInstructions($event.target.name, $event.target.files)" name="file"/>
						</td>
					</tr>
				 </table>
				</br>
				</br>
				</br>
			  <AdminAudition></AdminAudition>

			</div>
		
			<div class="faqs" v-if="currentPage==3">
				<h3>FAQS</h3>
				<h4>Add faq</h4>
				<table>
					  <tr>
						<td><input class="login_input" 
					autocomplete="off"
					placeholder="Question"
					v-model="faqQuestion"/></td>
						<td><td><input class="faq_input" 
					autocomplete="off"
					placeholder="Answer"
					v-model="faqAnswer"/></td>
						<td>	<div class="submit_input" v-on:click="postFAQ(faqQuestion,faqAnswer)">
							<label>Add Faq</label>
						</div>
						</td>
					</tr>
				</table>
				<table class="faqTable" v-if="faqs.length > 0">
					<tr>
						<th></th>
						<th>Question</th>
						<th>Answer</th>
						<th>rank</th>
						<th></th>
					</tr>
					<tr class="table-row" v-for="faq in faqs">
						<td><button v-on:click="deleteFAQ(faq.id)">
								Delete
						</button></td>
						<td><textarea rows="4" cols="50" class="table-faq-Input" 
								autocomplete="off"
								v-model="faq.question"
								/></td>
						<td><textarea rows="4" cols="50" class="table-faq-Input" 
								autocomplete="off"
								v-model="faq.answer"
								/></td>
						<td><textarea class="table-faq-Input2" 
								autocomplete="off"
								v-model="faq.rank"
								/></td>
						<td><button v-on:click="updateFAQ(faq.id,faq.question,faq.answer,faq.rank)">
								Save
						</button></td>
					</tr>
				 </table>
			</div>
			<div class="faqs" v-if="currentPage==4">
				<h3>Texts</h3>
				<div v-for="(text,textName) in texts">
				<h2>{{textName}}</h2>
				<table class="faqTable">
					<tr>
						<th>Text</th>
						<th>Value</th>
						<th></th>
					</tr>
					<tr class="table-row" v-for="(subText,subTextName) in text">
						<td><label class="table-faq-Input"
								>{{subText.textLabel}}</label></td>
						<td><textarea style="width: 600px;
	height:80px;" class="table-faq-Input2" 
								autocomplete="off"
								v-model="texts[textName][subTextName].value"
								/></td>
						<td><button v-on:click="updateTextTag(subText.textLabel,textName,subText.value)">
								Save
						</button></td>
					</tr>
				 </table>
			</div>
			</div>
			<div class="faqs" v-if="currentPage==5">
				<h3>TeamMembers</h3>
				<h4>Add team member</h4>
				<table>
					  <tr>
						<td><input class="login_input" 
					autocomplete="off"
					placeholder="member name"
					v-model="membername"/></td>
						<td><td><input class="login_input" 
					autocomplete="off"
					placeholder="title"
					v-model="title"/></td>
					<td><input class="login_input" 
					autocomplete="off"
					placeholder="info"
					v-model="info"/></td>
					<td><input class="login_input" 
					autocomplete="off"
					placeholder="picture"
					v-model="picture"/></td>
					<td><input class="login_input" 
					autocomplete="off"
					placeholder="song"
					v-model="song"/></td>
					<td><div class="login-select"> <select v-model:value="position">
								  <option value="">בחר קבוצה</option>
								  <option v-for="option in positionOptions"
									:value="option"
								  >{{option}}</option>
							</select>
							</div></td>
						<td>	<div class="submit_input" v-on:click="postTeamMember(membername,title,info,picture,song,position)">
							<label>Add TeamMember</label>
						</div>
						</td>
					</tr>
				</table>
				<div v-for="(members,membersGroup) in teamMembers">
				<h2>{{membersGroup}}</h2>
				<table class="faqTable">
					<tr>
						<th></th>
						<th>Name</th>
						<th>Title</th>
						<th>Info</th>
						<th>Picture</th>
						<th>Song</th>
						 <th>Group</th>
						<th></th>
					</tr>
					<tr class="table-row" v-for="(member,index) in members">
						<td><button v-on:click="deleteTeamMember(member.id)">
								Delete
						</button></td>
						<td><textarea rows="4" cols="50" class="login_input" 
								autocomplete="off"
								v-model="teamMembers[membersGroup][index].membername"
								/></td>
						<td><textarea rows="4" cols="50" class="login_input" 
								autocomplete="off"
								v-model="teamMembers[membersGroup][index].title"
								/></td>
						<td><textarea rows="4" cols="50" class="table-faq-Input" 
								autocomplete="off"
								v-model="teamMembers[membersGroup][index].info"/></td>
						<td>
						<img :alt="memberName" class="fillImg" v-if="picture!=''" :src="member.picture"/></br>
						<input type="file" v-on:change="uploadTeamObj($event.target.name, $event.target.files,'picture',member.id)" name="file"/></td>
						<td>
						<audio controls style="width:200px">
							<source :src="member.song" type="audio/mpeg">
							Your browser does not support the audio element.
						</audio></br>
						
						<input type="file" v-on:change="uploadTeamObj($event.target.name, $event.target.files,'song',member.id)" name="file"/>
						
						
						</td>
						<td><div class="login-select"> <select v-model:value="teamMembers[membersGroup][index].position">
								  <option value="">בחר קבוצה</option>
								  <option v-for="option in positionOptions"
									:value="option"
								  >{{option}}</option>
							</select>
							</div></td>
						<td><button v-on:click="updateTeamMember(member.id,teamMembers[membersGroup][index].membername,teamMembers[membersGroup][index].title,teamMembers[membersGroup][index].info,teamMembers[membersGroup][index].picture,teamMembers[membersGroup][index].song,teamMembers[membersGroup][index].position)">
								Save
						</button></td>
					</tr>
				 </table>
				</div>
				</div>
			<div class="faqs" v-if="currentPage==6">
			<div style="width:800px">
				<h3>Emails</h3>
				<h4>Selected Emails</h4>
				<div>
				<table class="faqTable">
					<tr>
						<th>צרו איתי קשר</th>
						<th>רישום לאודישן רית'ם</th>
						<th>רישום לאודישן אנסמבל</th>
					</tr>
					<tr class="table-row">
						<td><div class="login-select"> <select v-model:value="contactMeSelected">
								  <option v-for="email in emails"
									:value="email.id"
								  >{{email.email_name}}</option>
							</select>
							</div>
						</td>
						<td><div class="login-select"> <select v-model:value="rhythmEmailSelected">
								  <option v-for="email in emails"
									:value="email.id"
								  >{{email.email_name}}</option>
							</select>
							</div>
						</td>
						<td><div class="login-select"> <select v-model:value="ensambleEmailSelected">
								  <option v-for="email in emails"
									:value="email.id"
								  >{{email.email_name}}</option>
							</select>
							</div>
						</td>
						<td><div v-on:click="saveSelectedEmails()" class="menuButton admin-menuButton">
								Update
							</div>	
						</td>						
					</tr>
					<tr class="table-row">
						<td>
							<div v-on:click="sendDummyContactMe()" class="menuButton admin-menuButton">
								Test
							</div>
						</td>
						<td>
							<div v-on:click="sendDummyRythemEmail()" class="menuButton admin-menuButton">
								Test
							</div>
						</td>
						<td>
							<div v-on:click="sendDummyEnsambleEmail()" class="menuButton admin-menuButton">
								Test
							</div>
						</td>
					</tr>
				 </table>
				</div>
				<h4>Add email</h4>
				<input class="login_input" 
					autocomplete="off"
					placeholder="email name"
					v-model="newEmailName"/>
					<button v-on:click="addEmail()">
								Add
						</button>
				<h4>Edit emails</h4>
				<div>
				<table class="faqTable">
					<tr>
						<th></th>
						<th>Email list -click to edit</th>
					</tr>
					<tr v-for="email in emails" class="table-row">
						<td> 
							<button v-on:click="deleteEmail(email.id)">
								Delete
						</button>
						</td>
						<td> 
							<div v-on:click="editEmail(email)" class="menuButton admin-menuButton">
								{{email.email_name}}
							</div>	
						</td>
					</tr>
				 </table>
				</div>
				</div>
				<div v-if="editedEmailId > 0" style="border:solid;max-width:700px;height:1000px">
				
				<h3>Email edit</h3>
				<div><label>email name</label><input class="login_input" 
					autocomplete="off"
					placeholder="email name"
					v-model="editedEmailName"/></div>
				
				<div><label>subject</label><input class="login_input" 
					autocomplete="off"
					placeholder="email subject"
					v-model="editedEmailSubject"/></div>
				<div><label>email body</label></br><textarea rows="4" cols="50" class="table-faq-Input" 
								autocomplete="off"
								v-model="editedEmailText"/></div>
				<div><table class="faqTable">
					<tr>
						<th><button v-on:click="addAttachment()">
								Add
						</button></th>
						<th>Attachments</th>
					</tr>
					<tr v-for="attachment in editedEmailAttachments" class="table-row">
						<td> 
							<button v-on:click="removeEmailAttachment(attachment)">
								Delete
							</button>
						</td>
						<td> 
							<a :href="attachment" target="_blank"><h4>{{attachment}}</h4></a></br>
							<input v-if="attachment.length == 0" type="file" v-on:change="uploadEmailAttachment($event.target.name, $event.target.files)" name="file"/>
						</td>
					</tr>
				 </table>
				 </div>
						<div v-on:click="updateEmail()" class="menuButton admin-menuButton">
							Save Email Changes
						</div>		
				</div>
				
			</div>				
			</div>
			</div>
		</div>
			  
	</section>
</template>

<script>
  import axios from 'axios'
  var APIbase = "https://yard-bands.herokuapp.com"
   import Audition from '../components/Audition.vue'
  import AddCustomer from '../components/AddCustomer.vue'
   import AdminAudition from '../components/AdminAudition.vue'
  export default {
    components: {
      AddCustomer,AdminAudition,Audition
    },
	created () {
	},
	data() {
		return {
			auditionType:'Rhythm',
			loggedIn : false,
			currentPage : 0,
			faqs : [],
			auditions: [],
			settings: [],
			users: [],
			usersSortOption: null,
			customers: [],
			texts : {},
			contactMeSelected: 1,
			rhythmEmailSelected: 2,
			ensambleEmailSelected: 1,
			emails : [{id: 1,email_name: "email1",email_subject: "email subject",email_text: "text text text text text text",attachments: ["sdsd/sdsddsd/sd","/dsdsd/sdsd"]},
						{id: 2,email_name: "email22",email_subject: "email2 subject",email_text: "text text text2 text text text",attachments: ["sdsd/sdsddsd/sd"]}],
			newEmailName:"",
			editedEmailName:"",
			editedEmailId: -1,
			editedEmailSubject: "",
			editedEmailText: "",
			editedEmailAttachments: [],
			teamMembers : {},
			chosenAudition : 'Rhythm',
			audition_instructions:"",
			position: "",
			positionOptions: ['managment', 'managment2', 'members', 'office', 'managment2_north', 'members_north', 'office_north','founder']
		}
	},
	methods: {
		uploadAuditionInstructions(fieldName, fileList) {
			var safeThis = this;
			this.uploadFile(fieldName, fileList,'?context=email',function(result){
				if (result.upload != null) {
					alert("upload complete");
					safeThis.updateSettings("audition_file",result.upload);
					safeThis.audition_file = result.upload;
					this.$forceUpdate();
				}
			})
		},

		uploadEmailAttachment(fieldName, fileList) {
			var safeThis = this;
			const index = this.editedEmailAttachments.indexOf("");
			
			if (index !== -1) {
				this.editedEmailAttachments.splice(index, 1);
			}
			this.editedEmailAttachments.push("Uploading...");
			this.uploadFile(fieldName, fileList,'?context=email&id='+this.editedEmailId,function(result){
				if (result.upload != null) {
					const index = safeThis.editedEmailAttachments.indexOf("Uploading...");
					if (index !== -1) {
						safeThis.editedEmailAttachments.splice(index, 1);
					}
					safeThis.editedEmailAttachments.push(result.upload);
					safeThis.updateEmail();
				}
			})
		},
		saveSelectedEmails() {
			this.updateSettings("selectedRhythmEmail",this.rhythmEmailSelected)
			this.updateSettings("selectedEnsembleEmail",this.ensambleEmailSelected)
			this.updateSettings("selectedContactMeEmail",this.contactMeSelected)
		},
		removeEmailAttachment(attachment) {
				const index = this.editedEmailAttachments.indexOf(attachment);
			
			if (index !== -1) {
				this.editedEmailAttachments.splice(index, 1);
			}
			this.updateEmail();
		},
		addAttachment() {
			this.editedEmailAttachments.push("");
		},
		uploadTeamObj(fieldName, fileList,param,memberId) {
			var safeThis = this;
			this.uploadFile(fieldName, fileList,'?context=team&param='+param+'&id='+memberId,function(result){
				if (result.upload != null) {
					for (var teamType in safeThis.teamMembers) {
						
						for (var teamMember in safeThis.teamMembers[teamType]) {
							if (safeThis.teamMembers[teamType][teamMember].id === memberId) {
								safeThis.teamMembers[teamType][teamMember][param]=result.upload;
								safeThis.$forceUpdate();
							}
						}
					}
				}
			})
		},
		addEmail() {
			if (this.newEmailName != "") {
				axios.post(APIbase+'/emails',{
						"emailName": this.newEmailName
					})
					.then(response => {
					this.loadEmails();
					})
			}
		}
		,
		editEmail(email) {
			this.editedEmailName = email.email_name;
			this.editedEmailId = email.id;
			this.editedEmailSubject = email.email_subject;
			this.editedEmailText = email.email_text;
			if (email.email_attachments == null) {
				this.editedEmailAttachments = [];
			}
			else {
				this.editedEmailAttachments = email.email_attachments;
			}
			this.$forceUpdate();
		},
		deleteEmail(id) {
			axios.delete(APIbase+'/emails', {data:{"id":id}}).then(response => {
				this.loadEmails();
				this.$forceUpdate();
			}).catch(function (error) {
				
			});
		},
		uploadFile(fieldName, fileList,params,callback) {
			const formData = new FormData();
			if (!fileList.length) return;
			// append the files to FormData
			Array
			  .from(Array(fileList.length).keys())
			  .map(x => {
				formData.append(fieldName, fileList[x], fileList[x].name);
			  });
			const url = APIbase +"/upload"+params;
			axios.post(url, formData).then(function (response) {
				callback(response.data);
			})
		},
		registerNewUser(username,password) {
			var safeThis = this;
			axios.post(APIbase+'/signUp',{
						"username": username,
						"password": password
					})
					.then(response => {
					this.users.push({"user" : username})
					this.$forceUpdate();
					})
		},
		adminLogin(username,password) {
			var safeThis = this;
			axios.post(APIbase+'/login',{
						"user": username,
						"password": password
					})
					.then(response => {
						if (response.data.token.length > 0) {
							axios.defaults.headers.common['authorization'] = response.data.token;
							safeThis.loggedIn = true
							
							this.loadAuditions()
							this.loadFaqs()
							this.loadSettings()
							this.loadUsers()
							this.loadTexts()
							this.loadMembers()
							this.loadEmails()
							
						}
					})
		},
		createCSV() {
			var output = "data:text/csv;charset=utf-8,\uFEFF";
			output += ("מזהה יחודי,תאריך הוספה למערכת,שם,כלי ראשי,מייל,טלפון,סוג אודישן,רשום לאודישן,מספר עסקה" + "\n")
			for (var i =0; i < this.customers.length;i++) {
				output+= this.customers[i].user_id + ",";
				output+=  new Date(parseInt(this.customers[i].creation_time)).toString() + ",";
				output+= this.customers[i].name + ",";
				output+= this.customers[i].instrument + ",";
				output+= this.customers[i].email + ",";
				output+= this.customers[i].phone + ",";
				output+= this.customers[i].audition_type + ",";
				if (this.customers[i].booked_time) {
					output+= (this.customers[i].time ?  this.customers[i].day.split("T")[0] + " |    " + this.customers[i].time : "") + ",";
				}
				else {
					output+=  ",";
				}
				if (this.customers[i].booked_time) {
					output+=  this.customers[i].deal_id;
				}else {
					output+=  "";
				}
				output+="\n";
			}
			
			var encodedUri = encodeURI(output);
			//window.open(encodedUri);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "my_data.csv");
			document.body.appendChild(link); // Required for FF

			link.click(); 
		},
		selectAuditionType(newtype){
			this.chosenAudition = newtype;
		},
		loadAuditions() {
			var safeThis = this;
			axios.get(APIbase+'/auditionsRaw').then(response => {
				this.auditions = response.data
			}).catch(function (error) {
				
			});
		},
		loadFaqs() {
			var safeThis = this;
			axios.get(APIbase+'/faqs').then(response => {
				this.faqs = response.data
			}).catch(function (error) {
				
			});
		},		
		loadSettings() {
			var safeThis = this;
			axios.get(APIbase+'/adminSettings').then(response => {
				var res = {};
				for (var i = 0; i < response.data.length; i++) {
					res[response.data[i].name]=response.data[i].value;
				}
				this.settings = res
				this.rhythmEmailSelected = parseInt(res.selectedRhythmEmail)
				this.ensambleEmailSelected = parseInt(res.selectedEnsembleEmail)
				this.contactMeSelected = parseInt(res.selectedContactMeEmail)
				this.audition_instructions = res.audition_file;
			}).catch(function (error) {
				
			});
		},
		loadCustomers() {
			var safeThis = this;
			axios.get(APIbase+'/customers').then(response => {
				this.customers = response.data
				this.sortCustormersBy("creation_time")
			}).catch(function (error) {
				
			});
		},
		loadUsers() {
			var safeThis = this;
			axios.get(APIbase+'/users').then(response => {
				this.users = response.data
				
			}).catch(function (error) {
				
			});
		},
		sortCustormersBy(param) {
			var decending = false;
			if (this.usersSortOption == param) {
				decending = true;
				this.usersSortOption = null;
			}
			else {
				this.usersSortOption = param
			}
			if (isNaN(this.customers[param])) {
				this.customers.sort(
				  function(x, y)
				  {
					if (decending) {
						return (x[param].localeCompare(y[param]) * (-1)); 
					}
					else {
						return x[param].localeCompare(y[param]);  
					}
				  }
				);
			}
			else {
				this.customers.sort(
				  function(x, y)
				  {
					if (decending) {
						return ((parseInt(x[param]) - parseInt(y[param]))*(-1)); 
					}
					else {
						return parseInt(x[param]) - parseInt(y[param]);  
					}
				  }
				);
			}
		},
		loadTexts() {
			var safeThis = this;
			axios.get(APIbase+'/getAllTexts').then(response => {
				this.texts = response.data
			}).catch(function (error) {
				
			});
		},
		loadMembers() {
			var safeThis = this;
			axios.get(APIbase+'/team_text').then(response => {
				this.teamMembers = response.data
			}).catch(function (error) {
				
			});
		},
		loadEmails() {
			var safeThis = this;
			axios.get(APIbase+'/emails').then(response => {
				this.emails = response.data
			}).catch(function (error) {
				
			});
		},
		updateEmail() {
			var safeThis = this;
			axios.put(APIbase+'/emails',{id: this.editedEmailId,email_name: this.editedEmailName,email_subject: this.editedEmailSubject,email_text: this.editedEmailText,email_attachments: this.editedEmailAttachments}).then(response => {
				safeThis.loadEmails();
			}).catch(function (error) {
				
			});
		},
		sendDummyContactMe() {
			axios.post(APIbase+'/sendDummyEmail',{
				"emailId": this.contactMeSelected
			})
			.then(response => {
				console.log("email sent");
			});
		},
		sendDummyRythemEmail() {
			axios.post(APIbase+'/sendDummyEmail',{
				"emailId": this.rhythmEmailSelected
			})
			.then(response => {
				console.log("email sent");
			});

		},
		sendDummyEnsambleEmail() {
			axios.post(APIbase+'/sendDummyEmail',{
				"emailId": this.ensambleEmailSelected
			})
			.then(response => {
				console.log("email sent");
			});
		},
		updateTextTag(textlabel,context,textValue) {
			axios.put(APIbase+'/updateTextTag',{'textlabel':textlabel,'context':context ,'text_value':textValue}).then(response => {
				
			}).catch(function (error) {
				
			});
		},
		deleteUser(user) {
			
			axios.delete(APIbase+'/users',{data:{"time":audition.time,
												"day": audition.day}}).then(response => {
				this.auditions =  this.auditions.filter(function(item) { 
					return !(item.day == audition.day && item.time == audition.time)
				})	
			}).catch(function (error) {
				
			});
		},
		deleteCustomer(user) {
			axios.delete(APIbase+'/customers',{data:{"user_id":user}}).then(response => {
				this.customers =  this.customers.filter(function(item) { 
					return item.user_id != user
				})	
			}).catch(function (error) {
				
			});
		},
		postFAQ(faqQuestion,faqAnswer) {
			axios.post(APIbase+'/faqs',{"id":this.faqs.length,"question":faqQuestion,
												"answer": faqAnswer}).then(response => {
				
			}).catch(function (error) {
				
			});
		},
		deleteFAQ(faqId) {
			axios.delete(APIbase+'/faqs',{data:{"id":faqId}}).then(response => {
				
			}).catch(function (error) {
				
			});
		},
		updateFAQ(faqId,faqQuestion,faqAnswer,faqRank) {
			axios.put(APIbase+'/faqs',{"id":faqId,"question":faqQuestion,
												"answer": faqAnswer,"rank":faqRank}).then(response => {
				
			}).catch(function (error) {
				
			});
		},
		deleteUser(user_id) {
			axios.delete(APIbase+'/users',{data:{"user_id":user_id}}).then(response => {
				this.users = this.users.filter(function(item) { 
						return item.user !== user_id
				})
				this.$forceUpdate();
			}).catch(function (error) {
				
			});
		},
		updateSettings(settingName,settingValue) {
			axios.put(APIbase+'/adminSettings',{"name":settingName,"value": ""+ settingValue}).then(response => {
				
			}).catch(function (error) {
				
			});
		},
		postTeamMember(memberName,title,info,picture,song,position) {
			axios.post(APIbase+'/team_member',
			{"memberName":memberName,"title":title,"info":info,"picture":picture,"song":song,"position":position}).then(response => {
				this.loadMembers();

			}).catch(function (error) {
				
			});
		},
		updateTeamMember(id,memberName,title,info,picture,song,position) {
			axios.put(APIbase+'/team_member',
			{"id":id,"memberName":memberName,"title":title,"info":info,"picture":picture,"song":song,"position":position}).then(response => {
				this.loadMembers();
			}).catch(function (error) {
				
			});
		},
		deleteTeamMember(id) {
			axios.delete(APIbase+'/team_member', {data:{"id":id}}).then(response => {
				this.loadMembers();
			}).catch(function (error) {
				
			});
		}
		
	}
	
  }
</script>



// WEBPACK FOOTER //
// Admin.vue?4e4cfc86